import { convertDesign } from "../../../../message/editor/utils/convert-design";

import type { ChannelName } from "../../../../channels/types";
import type { SerialisedLexicalEditorDesign } from "../../../../message/editor/types/serialised-editor-design";
import type { ChatChannelRecipient } from "../../../../message/editor/utils/use-chat-channel-recipients";

const containsSurveyAnswers = (value: unknown): boolean => {
  if (!value || typeof value !== "object") return false;
  if ("type" in value && value.type === "survey-answers") return true;
  return Object.values(value).some(containsSurveyAnswers);
};

export function designContainsSurveyAnswers(design: SerialisedLexicalEditorDesign | null): boolean {
  return containsSurveyAnswers(design);
}

/** The design converted for another channel; see `convertDesign` for what each node becomes. */
export function convertLexicalDesign(
  from: NonNullable<ChannelName>,
  to: NonNullable<ChannelName>,
  design: SerialisedLexicalEditorDesign | null,
  slackVideoEnabled = false,
  slackChannelRecipients: ChatChannelRecipient[] = [],
  exclude: string[] = [],
): SerialisedLexicalEditorDesign {
  return convertDesign(from, to, design, { slackVideoEnabled, slackChannelRecipients, exclude })
    .design;
}
